/**
 * The name, set the way the logo sets it.
 *
 * One component so the wordmark cannot drift between the sidebar, the sign-in page and the
 * landing page — which is exactly what happened to every other brand detail in this app before it
 * had a single place to live.
 *
 * The separator is a dot on a disc of the lighter brand green. It reads as the dot of a domain
 * without spelling one out, and it stops "Rentor" and "NG" running together into one unfamiliar
 * word. It is drawn rather than typed, because a full stop between two words at this weight
 * disappears.
 *
 * **Drawn as SVG, not as a box inside a box.** Two nested elements are centred by percentages
 * that resolve to fractional pixels — at rail size the inner dot came out about 3.1px wide and
 * landed off-centre once the browser had rounded it. Concentric circles on a 24-unit grid cannot
 * do that at any size, and it is the same construction as `assets/logo/rentorng-wordmark.svg`,
 * so the two can no longer drift apart. The ratio is the asset's: 8 units of dot to 19 of disc.
 */

export function Wordmark({
  className = "",
  tone = "dark",
}: {
  className?: string;
  /** `dark` writes in ink, for a light background; `light` writes in white, for the rail. */
  tone?: "dark" | "light";
}) {
  return (
    <span
      className={`brand-word inline-flex items-baseline whitespace-nowrap ${
        tone === "light" ? "text-white" : "text-brand-900"
      } ${className}`}
    >
      Rentor
      <svg className="brand-dot" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="12" className="brand-dot-disc" />
        <circle cx="12" cy="12" r="5.05" className="brand-dot-pip" />
      </svg>
      NG
    </span>
  );
}
